import { EmptyResponse } from '../Core/CoreMessages';
import { IMessenger } from '../Messaging/IMessenger';
import { CheckNetworkMessage } from './CheckNetworkMessage';
import { CheckNetworkResponse } from './CheckNetworkResponse';
import { Symbol } from '../Core/Symbol';
import { INetworkService } from './INetworkService';
import { NetworkModule } from './NetworkModule';
import { DisplayOfflinePageMessage } from './DisplayOfflinePageMessage';
import { DismissOfflinePageMessage } from './DismissOfflinePageMessage';

/**
 * A service which retrieves information about the network.
 */
export class NetworkService implements INetworkService {
  constructor(private messenger: IMessenger) {
  }

  /**
   * Check network status.
   *
   * @return the promise, on what the callbacks about the scan results are delivered.
   */
  readonly check = (): Promise<CheckNetworkResponse> => {
    return this.messenger.send(new CheckNetworkMessage());
  }

  readonly symbol: Symbol = NetworkModule.serviceSymbol;

  /**
   * Request to show offline page.
   */
  readonly displayOfflinePage = (): Promise<EmptyResponse> => {
    return this.messenger.send(new DisplayOfflinePageMessage());
  }

  /**
   * Request to hide offline page.
   */
  readonly dismissOfflinePage = (): Promise<EmptyResponse> => {
    return this.messenger.send(new DismissOfflinePageMessage());
  }
}
